// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l6E-w","content":"styles_content__3Qgk3","row":"styles_row__3bUAC","footer":"styles_footer__3HD0F","phraseLength":"styles_phraseLength__f536M"};